import React, {useState} from 'react';
import {
    Box,
    Container,
    IconButton,
    Tab,
    Tabs,
    Tooltip,
    Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Link} from 'react-router-dom';
import EmitterTab from './EmitterTab';
import ProductsTab from './ProductsTab';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`invoice-settings-tabpanel-${index}`}
            aria-labelledby={`invoice-settings-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{py: 3}}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `invoice-settings-tab-${index}`,
        'aria-controls': `invoice-settings-tabpanel-${index}`,
    };
}

const InvoiceSettings: React.FC = () => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <Container maxWidth="lg" sx={{py: 4}}>
            <Box sx={{display: 'flex', alignItems: 'center', mb: 2, gap: 2}}>
                <Tooltip title="Zurück">
                    <IconButton
                        component={Link}
                        to="/rapporte-rechnung"
                        color="primary"
                    >
                        <ArrowBackIcon />
                    </IconButton>
                </Tooltip>
                <Typography variant="h4" component="h1">
                    Rechnungseinstellungen
                </Typography>
            </Box>

            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="Rechnungseinstellungen Tabs">
                    <Tab label="Rechnungsaussteller" {...a11yProps(0)} />
                    <Tab label="Produkte" {...a11yProps(1)} />
                </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
                <EmitterTab />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
                <ProductsTab />
            </TabPanel>
        </Container>
    );
};

export default InvoiceSettings;
